import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useRef, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { IPaperWork } from "../../models/IPaperwork";
import { Toast } from "primereact/toast";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { IDocumentMastDropdown } from "../../models/IDropdown";
import { UpoladDocument } from "./UpoladDocument";
import { ILogin } from "../../models/Login";

export interface IProps {
  singleData?: any,
  open?: boolean,
  hideDialog: () => void,
  po: IPurchaseOrder,
  payments?: any
}

export const Document = (props: IProps) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IPaperWork[], loading: boolean });
  const [paperWork, setPaperWork] = useState<IPaperWork>({ document_Type: "Consultant" });
  const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>();

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

  const onHide = () => {
    setPaperWork({ document_Type: "Consultant" });
    props.hideDialog();
    // reset();
    // setSelectedDocuments([]);
  };
  const toast = useRef<any>(null);

  const downloadDocument = async (data: IPaperWork) => {
    data.pO_ID = props.po.pO_ID;
    data.consultant_ID = props.po.consultant_ID;
    data.sub_Vendor_ID = props.po.sub_Vendor_ID;
    data.prime_Vendor_ID = props.po.prime_Vendor;
    const params = {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
      },
      body: JSON.stringify(data)
    };
    try {
      const response = await fetch(`${baseUrl}${"vwPODetailsExternalUser/document"}`, params);
      if (response.status === 200) {
        const blob = await response.blob();
        const href = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.download = data.document_Path ? data.document_Path : "document";
        a.href = href;
        a.click();
        a.href = '';
      } else if (response.status === 400) {
        const message = await response.text();
        toast.current.show({ severity: 'error', detail: message, life: 3000 });
      }
    } catch {
      toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
    }
  };

  const viewDocument = async (data: IPaperWork) => {
    data.pO_ID = props.po.pO_ID;
    data.consultant_ID = props.po.consultant_ID;
    data.sub_Vendor_ID = props.po.sub_Vendor_ID;
    data.prime_Vendor_ID = props.po.prime_Vendor;
    const params = {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
      },
    };
    try {
      const response = await fetch(`${baseUrl}${"vwPODetailsExternalUser/viewDocument"}?consultantID=${loginObj.consultant_ID}&path=${data.document_Path}`, params);
      if (response.status === 200) {
        const blob = await response.blob();
        const href = window.URL.createObjectURL(blob);
        window.open(href, '_blank');
        setTimeout(() => {
          window.URL.revokeObjectURL(href);
        }, 100);
      } else if (response.status === 400) {
        const message = await response.text();
        toast.current.show({ severity: 'error', detail: message, life: 3000 });
      }
    } catch {
      toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
    }
  };

  const file = (rowData: IPaperWork) => {
    return (<>
      {/* <span onClick={() => viewDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline">View</span> */}
      <span onClick={() => {
        if ((rowData.document_Name?.includes("Po") || rowData.document_Name?.includes("PO") || rowData.document_Name?.toLowerCase()?.includes("po")) && loginObj.user_Type !== 2) {
          downloadDocument({ ...rowData });
        } else if ((rowData.document_Name?.includes("Po") || rowData.document_Name?.includes("PO") || rowData.document_Name?.toLowerCase()?.includes("po") || rowData.document_Name?.toLowerCase()?.includes("Client") || rowData.document_Name?.toLowerCase()?.includes("Vendor")) && loginObj.user_Type === 2) {
          toast.current.show({ severity: 'error', detail: 'Do Not Have Access To View PO Document', life: 3000 });
        } else {
          downloadDocument({ ...rowData });
        }
      }} className="cursor-pointer text-cyan-700 underline ml-3">Download</span>
    </>);
  };

  const expiration_Date = (rowData: IPaperWork) => {
    let date;
    if (rowData.expiration_Date) date = format(new Date(rowData.expiration_Date), 'dd/MM/yyyy').toUpperCase();
    else date = "";
    return (<>{date}</>);
  };

  const loadDocuments = async (type?: string) => {
    const response = await Fetch("Dropdown/document", "GET", null, null, null);
    if (response) {
      const data: Array<any> = await response.json();
      const consultant: Array<any> = [];
      // const Vendor: Array<IDocumentMastDropdown> = [];
      // const Client: Array<IDocumentMastDropdown> = [];
      data.forEach((d: any) => {
        if (!(d.document_Name.includes("Vendor") || d.document_Name.includes("Client"))) consultant.push(d);
        // if ((d.document_Name.includes("Vendor"))) Vendor.push(d);
        // if ((d.document_Name.includes("Client"))) Client.push(d);
      });
      if (type === "Consultant") {
        setDocuments(consultant);
      }
      //  else if (type === "Vendor") {
      //   setDocuments(Vendor);
      // } else if (type === "Client") {
      //   setDocuments(Client);
      // } else {
      //   setDocuments(consultant);
      // }

    }
  }

  // const saveDocument = async (body: IPaperWork, isDelete?: boolean) => {
  //   // setLoading(true);
  //   body.pO_ID = props.po.pO_ID;
  //   body.consultant_ID = props.po.consultant_ID;
  //   body.sub_Vendor_ID = props.po.sub_Vendor_ID;
  //   body.prime_Vendor_ID = props.po.prime_Vendor;
  //   if (isDelete) {
  //     const response = await Fetch("vwPODetails/apw", "DELETE", body, null, toast);
  //     if (response) {
  //       toast.current.show({ severity: 'success', content: `Document Deleted Successfully` });
  //       setPaperWork({ document_Type: "Consultant" });
  //       // loadDocumentsList();
  //     }
  //     // } else setLoading(false);
  //   } else {
  //     const method = body.document_ID ? "PUT" : "POST";
  //     const message = body.document_ID ? "Updated Successfully" : "Added Successfully";

  //     const response = await Fetch("vwPODetails/apw", method, body, null, toast);
  //     if (response) {
  //       toast.current.show({ severity: 'success', content: `Document ${message}` });
  //       setPaperWork({ document_Type: "Consultant" });
  //       // loadDocumentsList();
  //     }
  //     // } else setLoading(false);
  //   }
  // }

  const actionBodyTemplate = (rowData: IPaperWork) => {
    return <div style={{ display: 'flex' }}>
      <Button icon="pi pi-pencil" label="Update" className="p-button-rounded  p-button-text" onClick={() => {
        // loadDocuments(rowData.document_Type);
        setPaperWork({ ...rowData });
      }} />
      {/* <Button icon="pi pi-trash" label="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => saveDocument({ ...rowData }, true)} /> */}
    </div>
  };

  const consultantDocuments = async (poID: number) => {
    const response = await Fetch("vwPODetailsExternalUser/apw", "GET", null, `po_id=${poID}`, null);
    if (response) {
      const data = await response.json();
      setTableData({ tableData: data.consultant_documents, loading: false });
      // console.log(data);
    }
  };

  const reloadData = () => {
    if (props.open && props.po.pO_ID) {
      consultantDocuments(props.po?.pO_ID);
    };
  }

  const rowClass = (data: IPaperWork) => {
    return {
      'bg-orange-300 text-black': new Date(data?.expiration_Date || "").getDay() <= 7,
      'bg-pink-400 text-black': new Date(data?.expiration_Date || "") > new Date(),
      // 'bg-pink-300 text-black': data.expiration_Date,
      // 'bg-orange-300 text-black': data.expiration_Date,

    };
  }

  useEffect(() => {
    if (props.open && props.po.pO_ID) {
      consultantDocuments(props.po?.pO_ID);
    };
  }, [props.po, props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "50vw" }} header="Add/Edit/View My Documents" modal className="p-fluid" onHide={onHide}>
      <div>
        <UpoladDocument po={props.po} paperWork={paperWork} reloadData={reloadData} />
        <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
          size="small"
          value={tableData.tableData}
          header="Document List"
          showGridlines
          stripedRows
          loading={tableData.loading}
          rowClassName={rowClass}
        >
          <Column field="document_Name" header="Document Name" />
          <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
          <Column field="file" header="File" body={file} />
          {/* <Column field="addedByName" header="Added By" /> */}
          {/* <Column field="editedByName" header="Edited By" /> */}
          {/* <Column field="document_Status" header="Status" /> */}
          <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
        </DataTable>
        {/* </Card> */}
      </div>
      <Toast ref={toast} />
    </Dialog>
  );
};
